import Platform from "../../../../libs/utility/Platform";

export default {

    recipientListContainer: {
        display: "flex",
        columnGap: "40px",
    },

    headerContainer: {
        width: "100%",
        padding: "10px 20px 0px 20px",
    },

    titleAndSearch: {
        paddingBottom: "30px",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "22px",
        flexWrap: 'wrap',
        rowGap: "15px"
    },

    icons: {
        display: "flex",
        columnGap: '15px',
        alignItems: "center"
    },

    cardContainer: {
        width: "40%",
    },

    selectAllBox: {
        padding: "16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: Platform.isMobileView() ? "100%" : '40%',
    },

    noRecipientsFoundContainer: {
        textAlign: "center",
        marginTop: "100px"
    },

    searchContainer: {
        display: "flex",
    },

    dropdownContainer: {
        width: "135px",
        marginRight: "20px"
    },

    dropdownInput: {
        caretColor: "transparent",
    },

    recipientInformationContainer: {
        background: "#FFFFFF",
        boxShadow: "0px 10px 10px rgba(38, 38, 38, 0.05)",
        borderRadius: "12px",
        width: "60%",
        padding: "40px"
    },

    selectPayerContainer: {
        display: "flex",
        columnGap: "21px",
        alignItems: "center",
    },

    payerdropdown: {
        flexDirection: "row",
        margin: "0px",
    },

    payerdropdownContainer: {
        width: "auto",
        margin: "0px"
    },

    payerSearchInput: {
        width: "400px"
    },

    filtersContainer: {
        margin: "30px 0px",
        display: "grid",
        gridTemplateColumns: "repeat(4, auto)",
        gridGap: "40px",
    },

    selectDropdown: {
        width: "100%"
    },

    buttonContainer: {
        display: "flex",
        columnGap: "5px"
    },

    button: {
        padding: "6px 22px"
    },

    tinMatchPopup: {
        maxWidth: "600px"
    },


    calendarBox: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "end",
    },

    calendarButtonsContainer: {
        display: "flex",
        borderBottom: "1px solid #262626"
    },

    calendarButton: {
        marginBottom: "8px",
        padding: "0 5px"
    },

    bulkAddressMatchPopup: {
        width: "60%",
        maxWidth: "none"
    },

    popupButton: {
        minWidth: "140px",
        minHeight: "40px",
        fontWeight: "600"
    },

    leftLiftOptionsRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
    }

}